import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ToolbarColor {
    backgroundColor: string;
    iconColor: string;
}

@Injectable()
export class SharedService {
    public isFirstEventFromWrapper = new BehaviorSubject<boolean>(false);
    public chatIconClicked = new Subject();
    public notificationIconClicked = new Subject();
    public toolbarColorEvent = new ReplaySubject<ToolbarColor>();
    public toolbarSubject = new Subject();
    public contactPersonsSubject = new Subject();
    public chatInboxCloseSubject = new Subject();
    backBtnClicked: Subject<number> = new BehaviorSubject<number>(-1);
    public statusbarEventSubject = new Subject<number>();
    public reconnectWebsocketEvent = new Subject();
    
    setStatusBarHeight(data) {
        this.statusbarEventSubject.next(data);
    }

    sendToolbarData(toolbarData) {
        this.toolbarSubject.next(toolbarData);
        console.log(toolbarData);
    }

    sendContactPersons(data) {
        this.contactPersonsSubject.next(data);
    }

    sendChatInboxCloseEvent(){
        this.chatInboxCloseSubject.next(true);
    }

    reconnectWebSocket(){
        console.log("inside shared service");
        this.reconnectWebsocketEvent.next(true);
    }

    constructor() {}

    // setCurrentColorEmitter(bg:ToolbarColor) {
    //   this.toolbarColorEvent.next(bg);
    // }
}
